export default "__VITE_ASSET__B2BsI1rB__"